import { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp, FaPlus, FaTimes } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

const SelectSearchApi = ({
  list = [],
  label = 'Select Option',
  getOptionLabel = (item) => item.label,
  getOptionValue = (item) => item.value,
  getTypeValue = () => {},
  value = '',
  onChange = () => {},
  onApiChange = () => {},
  error = false,
  placeholder = '',
  disabled = false,
  createNewUrl = '', 
  createNewLabel = 'Create New', 
  createState = {}, 
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
      const selectedItem = list.find((item) => getOptionValue(item) === value);
      if (selectedItem) {
        setSearchTerm(getOptionLabel(selectedItem));
      }
  }, [value, list, getOptionLabel, getOptionValue]);

  const filteredList = list.filter((item) => {
    const label = getOptionLabel(item);
    return typeof label === 'string' && label.toLowerCase().includes((searchTerm || '').toLowerCase());
  });

  const handleSelect = (item) => {
    if (disabled) return;
      onApiChange(item.value);
      setTimeout(() => {   
        const val = getOptionValue(item);
        setSearchTerm(getOptionLabel(item));
        onChange(val);
        setShowOptions(false);
      }, 120);
  };

  const handleClear = () => {
    if (disabled) return;
    setSearchTerm('');
    onChange('');
    setShowOptions(false);
  };

  const handleCreateNew = () => {
    if (disabled || !createNewUrl) return;
    navigate(createNewUrl, { state: createState });
  };

  const toggleOptions = () => {
    if (!disabled) {
      setShowOptions(!showOptions);
      setIsFocused(!showOptions);
    }
  };

  const createNewStyle = {
    fontSize: '0.8rem',
    padding: '0.45rem 1rem',
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#6F3355',
    border: 'none',
    borderRadius: '8px 8px 0 0',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#fff',
    fontWeight: '600',
  };

  return (
    <div className="custom-date-wrapper" style={{ position: 'relative', width: '100%' }}>
      <label
        style={{ 
          fontSize: "0.8rem", 
          padding: '0.1rem 0.3rem',
          fontWeight: 500,
          color: '#333'
        }}
      >
        {label}
      </label>

      {/* Input box */}
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          className={`form-control custom-date-input ${error ? 'errorborder' : ''}`}
          placeholder={placeholder || label}
          value={searchTerm}
          onChange={(e) => {
            if (!disabled) {
              setSearchTerm(e.target.value);
              getTypeValue(e.target.value);
              setShowOptions(true);
              onApiChange(e.target.value);
            }
          }}
          onFocus={() => {
            if (!disabled) {
              setShowOptions(true);
              setIsFocused(true);
            }
          }}
          onBlur={() => {
            if (!disabled) {
              setTimeout(() => {
                setShowOptions(false);
                setIsFocused(false);
              }, 299);
            }
          }}
          style={{
            fontSize: '0.85rem',
            padding: '0.55rem 2.2rem 0.55rem 0.8rem',
            height: '30px',
            borderRadius: '8px',
            border: error ? '1px solid red' : isFocused ? '1px solid #6F3355' : '1px solid #ccc',
            backgroundColor: disabled ? '#f8f6f6' : 'white',
            boxShadow: isFocused ? '0 0 0 3px rgba(111,51,85,0.1)' : 'none',
            width: '100%',
            transition: 'all 0.2s ease',
            cursor: disabled ? 'not-allowed' : 'text',
          }}
          autoComplete="off"
          readOnly={disabled}
        />

        {/* Clear & Chevron Icons */}
        {!disabled && (
          <div 
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            {searchTerm && (
              <FaTimes 
                size={11} 
                onClick={handleClear}
                style={{
                  cursor: 'pointer',
                  color: '#888',
                }}
              />
            )}
            <div 
              style={{
                cursor: 'pointer',
                color: '#6F3355',
              }}
              onClick={toggleOptions}
            >
              {showOptions ? <FaChevronUp size={11} /> : <FaChevronDown size={11} />}
            </div>
          </div>
        )}
      </div>

      {/* Dropdown */}
      {!disabled && showOptions && (
        <ul 
          className="dropdown-menu show w-100 mt-1"
          style={{
            position: 'absolute',
            zIndex: 1000,
            maxHeight: '220px',
            overflowY: 'auto',
            border: '1px solid rgba(0,0,0,.1)',
            borderRadius: '10px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
            backgroundColor: 'white',
            left: 0,
            padding: 0,
          }}
        >

          {createNewUrl && (
            <li>
              <button
                className="dropdown-item-custom"
                type="button"
                onClick={handleCreateNew}
                style={createNewStyle}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#7A3C61')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#6F3355')}
              >
                <FaPlus size={10} />
                {createNewLabel}
              </button>
            </li>
          )}
            
          {filteredList.length > 0 ? (
            filteredList.map((item, index) => (
              <li key={index}>
                <button
                  className="dropdown-item-custom"
                  type="button"
                  onClick={() => handleSelect(item)}
                  style={{ 
                    fontSize: '0.85rem',
                    padding: '0.5rem 1rem',
                    width: '100%',
                    textAlign: 'left',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    borderBottom: '1px solid #f2f2f2'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#F5ECF0'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  {getOptionLabel(item)}
                </button>
              </li>
            ))
          ) : (
            <li 
              className="dropdown-item text-muted" 
              style={{ 
                fontSize: '0.85rem',
                padding: '0.5rem 1rem',
              }}
            >
              No results found
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectSearchApi;
